import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import VueResource from 'vue-resource';
import createPersistedState from 'vuex-persistedstate';
import VueFormulate from '@braid/vue-formulate';
import TestComponent from '../vue/TestComponent.vue';
import LoadingAnimation from '../vue/LoadingAnimation.vue';
import SiteHeader from '../vue/SiteHeader.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import SiteButton from '../vue/SiteButton.vue';
import SiteButtonInput from '../vue/SiteButtonInput.vue';
import FeatureImageContentSection from '../vue/FeatureImageContentSection.vue';
import ImageContentSection from '../vue/ImageContentSection.vue';
import ArticleList from '../vue/ArticleList.vue';
import ArticleListItem from '../vue/ArticleListItem.vue';
import TeamMemberList from '../vue/TeamMemberList.vue';
import TeamMemberListItem from '../vue/TeamMemberListItem.vue';
import BackToTopButton from '../vue/BackToTopButton.vue';
import ScrollToLink from '../vue/ScrollToLink.vue';
import ImageGallery from '../vue/ImageGallery.vue';
import PageHeader from '../vue/PageHeader.vue';
import LogosList from '../vue/LogosList.vue';
import ResourceList from '../vue/ResourceList.vue';
import SiteButtonSubmit from '../vue/SiteButtonSubmit.vue';
import VideoModal from '../vue/VideoModal.vue';
import SitePagination from '../vue/SitePagination.vue';
import PageDivider from '../vue/PageDivider.vue';
import PostHeader from '../vue/PostHeader.vue';
import FeatureWelcome from '../vue/FeatureWelcome.vue';
import EditableTable from '../vue/EditableTable.vue';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(VueFormulate);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {},
      getters: {},
      mutations: {},
      actions: {},
      plugins: [createPersistedState()],
    });

    new Vue({
      store: store,
      router,
      data: {
        topScrollThreshold: 100,
        isScrolled: false,
        isPageReady: false,
      },

      components: {
        TestComponent,
        SiteHeader,
        SiteFooter,
        SiteButton,
        FeatureImageContentSection,
        ImageContentSection,
        ArticleList,
        ArticleListItem,
        TeamMemberList,
        TeamMemberListItem,
        BackToTopButton,
        ScrollToLink,
        SiteButtonInput,
        ImageGallery,
        PageHeader,
        PostHeader,
        LogosList,
        ResourceList,
        SiteButtonSubmit,
        VideoModal,
        LoadingAnimation,
        SitePagination,
        PageDivider,
        FeatureWelcome,
        EditableTable,
      },

      methods: {
        onRefreshAos: function() {
          AOS.refresh();
        },
        didScroll() {
          this.isScrolled = window.scrollY > this.topScrollThreshold;
        },
      },

      created() {
        window.addEventListener('scroll', this.didScroll);
      },

      destroyed() {
        window.removeEventListener('scroll', this.didScroll);
      },

      mounted() {
        var self = this;
        setTimeout(function() {
          self.isPageReady = true;
          AOS.init();
        }, 500);

        // eslint-disable-next-line no-unused-vars
        self.$Lazyload.$on('loaded', function(
          {
            bindType,
            el,
            naturalHeight,
            naturalWidth,
            $parent,
            src,
            loading,
            error,
          },
          formCache
        ) {
          // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
          // so refreshing it in order to re-calculate trigger points
          EventManager.$emit('should-refresh-aos');
        });
      },
    }).$mount('#app');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js